<template>
	<Modal @requestUnmount="$emit('safeToUnmount')" width="sm">
		<template #header>
			<div class="font-semibold text-lg mb-2">{{ $t("Delete collection") }}</div>
		</template>

		<template #default="modalActions">
			<div class="text-danger p-4 rounded-lg mb-2">
				<i18n-t keypath="Are you sure you want to delete the collection {name}?" tag="p" class="mb-3">
					<template #name>
						<span class="italic font-bold">"{{ collection.name }}"</span>
					</template>
				</i18n-t>
				<p class="text-sm text-base-content">
					{{ $t('This will only delete the collection, not the lesson plans. All lesson plans in this collection will remain available in your library.') }}
				</p>
			</div>

			<div class="modal-footer flex justify-end gap-1 overflow-hidden">
				<button class="btn btn-ghost" @click="modalActions.hide">{{ $t("No") }}</button>
				<button class="btn btn-danger" :disabled="processing" @click="confirmDelete(modalActions)">{{ $t("Yes") }}</button>
			</div>
		</template>
	</Modal>
</template>

<script lang="ts">
import { useLessonPlanCollectionsStore } from "@/stores/LessonPlanCollections.store";
import { LessonPlanCollection } from "@/models/LessonPlanCollection.model";
import Modal from "@/components/ui/Modal.vue";
import { mapStores } from "pinia";
import type { PropType } from 'vue';

export default {
	name: "LessonPlanCollectionDeleteModal",

	components: {
		Modal,
	},

	props: {
		collection: {
			type: Object as PropType<LessonPlanCollection>,
			required: true,
		},
	},

	emits: ["deleted", "safeToUnmount"],

	data() {
		return {
			processing: false,
		};
	},

	computed: {
		...mapStores(useLessonPlanCollectionsStore),
	},

	methods: {

		async confirmDelete(modalActions: any) {
			this.processing = true;
			try {
				await this.lessonPlanCollectionsStore.delete(this.collection);
				this.$emit("deleted");
				modalActions.hide();
			} catch (error) {
				console.error("Failed to delete collection:", error);
				// Optionally show an error message to the user here
			} finally {
				this.processing = false;
			}
		},

	},
};
</script>
